export default __webpack_public_path__ + "static/media/Banner-anuva.fb8be75a.png";